import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AppsIcon from '@material-ui/icons/Apps';
import DashboardIcon from '@material-ui/icons/Dashboard';
import EventNoteIcon from '@material-ui/icons/EventNote';

import MainAppBar from '../../containers/main-appbar';
import MainContent from '../../containers/main-content';
import MainDrawer from '../../containers/main-drawer';
import ProjectSelector from '../../containers/main-project-selector';
import { withDefaultStyles } from '../../utils/material-ui/hoc';
import Content from './containers/content';

class TenantMain extends React.Component<any, any> {
  public render() {
    return (
      <div style={this.props.style}>
        <MainAppBar title='Tenant'>
          <ProjectSelector style={{ width: '30%' }} />
        </MainAppBar>
        <MainDrawer selectedMenu='tenant'>
          <List>
            <ListItem button={true} key='integrations' onClick={this.navToIntegrations}>
              <ListItemIcon><AppsIcon /></ListItemIcon>
              <ListItemText>Integrations</ListItemText>
            </ListItem>
            <ListItem button={true} key='expstd'>
              <ListItemIcon><DashboardIcon /></ListItemIcon>
              <ListItemText>Experience Studio</ListItemText>
            </ListItem>
            <ListItem button={true} key='reports' onClick={this.navToReports}>
              <ListItemIcon><EventNoteIcon /></ListItemIcon>
              <ListItemText>Reports</ListItemText>
            </ListItem>
          </List>
        </MainDrawer>
        <MainContent>
          <Content />
        </MainContent>
      </div>
    );
  }
  private navToIntegrations = () => this.props.history.push('/console/tenants/' + this.props.tenant.id + '/integrations')
  private navToReports = () => this.props.history.push('/console/tenants/' + this.props.tenant.id + '/reports')
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(TenantMain)));



// WEBPACK FOOTER //
// ./src/sub-projects/tenant/main.tsx